export enum SourceType {
  SHIPMENT = "ShipmentTelematics",
  CONNECTED_CAR = "EntityTelematics",
  MILESTONE = "MilestoneTelematics",
  TAG = "TagTelematics",
}

export enum EventCode {
  POSITION_UPDATED = "PositionUpdated",
  PLANNED_TRIP_LEG_CREATED = "PlannedTripLegCreated",
  PLANNED_TRIP_LEG_UPDATED = "PlannedTripLegUpdated",
  ACTUAL_TRIP_LEG_CREATED = "ActualTripLegCreated",
  ACTUAL_TRIP_LEG_UPDATED = "ActualTripLegUpdated",
  ACTUAL_TRIP_LEG_COMPLETED = "ActualTripLegCompleted",
  PROGRESS_UPDATED = "ProgressUpdated",
  ENTITY_UPDATED = "EntityUpdated",
  ENTITY_LIFE_CYCLE_UPDATE = "EntityLifeCycleUpdate",
  EXCEPTION_CREATED = "ExceptionCreated",
  EXCEPTION_CLEARED = "ExceptionCleared",
  HOLD_CREATED = "HoldCreated",
  HOLD_CLEARED = "HoldCleared",
  ENTITY_CREATED = "EntityCreated",
  ENTITY_DELETED = "EntityDeleted",
  ACTUAL_TRIP_LEG_DELETED = "ActualTripLegDeleted",
  ACTUAL_TRIP_LEG_ARRIVED_ORIGIN = "ActualTripLegArrivedOrigin",
  ACTUAL_TRIP_LEG_DEPARTED_ORIGIN = "ActualTripLegDepartedOrigin",
  ACTUAL_TRIP_LEG_ARRIVED_DESTINATION = "ActualTripLegArrivedDestination",
  ACTUAL_TRIP_LEG_DEPARTED_DESTINATION = "ActualTripLegDepartedDestination",
  PLANNED_TRIP_LEG_DELETED = "PlannedTripLegDeleted",
  TRIP_PLAN_COMPLETED = "TripPlanCompleted",
  START_TRANSIT_TIMER = "StartTransitTimer",
  END_TRANSIT_TIMER = "EndTransitTimer",
  STATUS_UPDATED = "StatusUpdated",
}

export const CarrierPartnerAndDealerTripSummaryEventCodes = [
  EventCode.HOLD_CREATED,
  EventCode.HOLD_CLEARED,
  EventCode.ENTITY_DELETED,
  EventCode.ACTUAL_TRIP_LEG_DELETED,
  EventCode.ACTUAL_TRIP_LEG_ARRIVED_ORIGIN,
  EventCode.ACTUAL_TRIP_LEG_DEPARTED_ORIGIN,
  EventCode.ACTUAL_TRIP_LEG_ARRIVED_DESTINATION,
  EventCode.ACTUAL_TRIP_LEG_DEPARTED_DESTINATION,
  EventCode.PLANNED_TRIP_LEG_DELETED,
  EventCode.START_TRANSIT_TIMER,
  EventCode.END_TRANSIT_TIMER,
  EventCode.STATUS_UPDATED,
];

export const ShipperTripSummaryEventCodes = [
  ...CarrierPartnerAndDealerTripSummaryEventCodes,
  EventCode.ENTITY_CREATED,
  EventCode.TRIP_PLAN_COMPLETED,
  EventCode.EXCEPTION_CREATED,
  EventCode.EXCEPTION_CLEARED,
  EventCode.ENTITY_LIFE_CYCLE_UPDATE,
];

export enum ExceptionEventSubcode {
  T = "T",
}

export enum DiagnosticState {
  WARNING = "warning",
  CRITICAL = "critical",
  GOOD = "good",
}

export enum DiagnosticStateColors {
  WARNING = "#dbb800",
  CRITICAL = "#d5473f",
  GOOD = "#46b630",
}

export enum CurrentLocationType {
  AT_LOCATION = "atlocation",
  ON_THE_WATER = "onthewater",
  ON_RAIL = "onrail",
  ON_THE_ROAD = "ontheroad",
}

export enum EntityStatus {
  ACTIVE = "Active",
  DELIVERED = "Delivered",
  COMPLETE = "Complete",
}

export enum InventoryStatus {
  SHIPPABLE = "Shippable",
  NONSHIPPABLE = "Non-Shippable",
}

export enum InitialETADuration {
  MISSED_FIRST_ETA = "Missed First ETA",
  HOURS_0_47_OUT = "0-47 Hours Out",
  HOURS_48_95_OUT = "48-95 Hours Out",
  HOURS_96_OUT = "96+ Hours Out",
  BEYOND_PAST_72_HOURS = "72+ Hours Past ETA",
  WITHIN_PAST_72_HOURS = "1-72 Hours Past ETA",
}

export enum TimeOnSiteDuration {
  DAYS_10 = "10+ Days",
  DAYS_6_9 = "6-9 Days",
  DAYS_3_5 = "3-5 Days",
  DAYS_0_2 = "0-2 Days",
  ALL = "All On Site",
  NONE = "Not Yet On Site",
}

export enum GateReleaseThreshold {
  DAYS_AGO_150 = "150+ Days ago",
  DAYS_AGO_100_149 = "100-149 Days ago",
  DAYS_AGO_50_99 = "50-99 Days ago",
  DAYS_AGO_0_49 = "0-49 Days ago",
}

export enum DepartedSource {
  MILESTONE = "milestone",
  DERIVED_BY_MILESTONE = "derivedByMilestone",
  DERIVED_BY_DELIVERY = "derivedByDelivery",
}

export enum RequestMethod {
  GET = "GET",
  POST = "POST",
}
